import { Component, input, output, signal } from '@angular/core'
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap'
import { Me } from 'src/app/shared/interfaces/me/me.interface'
import { OffCanvasComponent } from '../../off-canvas/off-canvas.component'
import { OffCanvasConfig } from '../../off-canvas/off-canvas-config'
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome'
import { BooleanIconComponent } from '../../form-elements/boolean-icon/boolean-icon.component'
import { CurrencyPipe } from '@angular/common'
import { CompanySetting } from 'src/app/shared/interfaces/company-setting/company-setting.interface'
import { ButtonComponent } from '../../form-elements/button/button.component'

@Component({
    selector: 'sf-sidebar-starter-user-icon',
    imports: [
        NgbDropdownModule,
        FontAwesomeModule,
        NgbTooltipModule,
        BooleanIconComponent,
        OffCanvasComponent,
        ButtonComponent,
        CurrencyPipe,
    ],
    templateUrl: './sidebar-starter-user-icon.component.html',
    styleUrl: './sidebar-starter-user-icon.component.scss',
    host: {
        class: 'mb-4 mt-1',
    },
})
export class SidebarStarterUserIconComponent {
    user = input<Me | null>(null)
    companySettings = input.required<CompanySetting>()
    requestChangePassword = output<void>()

    companySettingsOffCanvasConfig: OffCanvasConfig = { position: 'end' }
    showExtendedSettings = signal(false)

    logout = output()
}
